import {
  CreateVaccinationActBodyVaccinationAct,
  VaccinationAct,
  VaccinationActApiInterface,
} from "@syadem/kairos-citizen-js";
import { ActionResult } from "../actionResult";
import { Service } from "./service";

interface Payload {
  vaccinationAct: CreateVaccinationActBodyVaccinationAct;
  healthRecordId: string;
}

function normalizeVaccinationAct(vaccinationAct: CreateVaccinationActBodyVaccinationAct) {
  const normalizeValue = (value: unknown): unknown => {
    if (value === "" || value === undefined) return null;
    if (value instanceof Date) return value;
    if (Array.isArray(value)) return value.map(normalizeValue);

    if (value !== null && typeof value === "object") {
      return Object.fromEntries(
        Object.entries(value).map(([field, fieldValue]) => [field, normalizeValue(fieldValue)])
      );
    }

    return value;
  };

  return normalizeValue(vaccinationAct) as CreateVaccinationActBodyVaccinationAct;
}

export class CreateVaccinationActService implements Service<Payload, VaccinationAct> {
  constructor(private readonly vaccinationActApi: VaccinationActApiInterface) {}

  async call({ vaccinationAct, healthRecordId }: Payload): Promise<ActionResult<VaccinationAct>> {
    const normalizedVaccinationAct = normalizeVaccinationAct(vaccinationAct);

    const apiVaccinationAct = (
      await this.vaccinationActApi.createVaccinationAct(
        healthRecordId,
        { vaccinationAct: normalizedVaccinationAct }
      )
    ).vaccinationAct;

    return {
      type: "success",
      value: apiVaccinationAct,
    };
  }
}
